import brandIcons from '@/config/brands'
import _ from 'lodash'

const brandIconBg = {
  methods: {
    // 업체 아이콘 처리
    brandIconBg (companyName) {
      let tt = _.find(brandIcons, function (brand) {
        return brand.name === companyName
      })
      if (tt) {
        return `background-image: url('/img/company/${tt.icon}.png')`
      } else {
        return `background-image: url('/img/company/0.png')`
      }
    }
  }
}

export default brandIconBg
